<!-- warning modal: shows when user made changes navigates away  -->
<clr-modal [(clrModalOpen)]="warningOpened" [clrModalSize]="'lg'">
  <h3 class="modal-title">Warning: Unsaved Changes</h3>
  <div class="modal-body">
    <p>There are unsaved changes on this page. Any unsaved changes will be lost.
      <br>Are you sure you want to leave this page?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" id="btnNo" (click)="stayOnPage()">
      Stay on this Page
    </button>
    <button type="button" class="btn btn-primary" id="btnYes">
      Leave this Page
    </button>
  </div>
</clr-modal>